import * as angular from "angular";
import {IController} from 'angular';
import {LogisticsVehicle} from "../../models/logistics-vehicle.model";
import {LogisticsVehicleStatusType} from "../../types/logistics-vehicle-status.type";

export class LogisticsVehicleSelectItemComponent implements IController {

  logisticVehicle: LogisticsVehicle;
  onSelect: Function;

  public logisticsVehicleStatusType: typeof LogisticsVehicleStatusType = LogisticsVehicleStatusType;

  constructor() {
  }

  $onInit() {

  };


}

angular
  .module('bringoz.admin.commons')
  .component('logisticsVehicleSelectItem', {
    bindings: {
      logisticVehicle: '<',
      isExcluded: '<?'
    },
    template: require('./logistics-vehicle-select-item.html').default,
    controller: LogisticsVehicleSelectItemComponent
  });
